import { STRINGS } from "./strings";

export interface Question {
  id: string;
  text: string;
  shortLabel: string;
  scaleHint?: { low: string; high: string };
}

export const QUESTIONS: Question[] = [
  {
    id: "q_recommend",
    text: STRINGS.questionRecommend,
    shortLabel: "Weiterempfehlung",
    scaleHint: { low: STRINGS.scaleHintLow, high: STRINGS.scaleHintHigh },
  },
  {
    id: "q_overall",
    text: STRINGS.questionOverall,
    shortLabel: "Gesamtzufriedenheit",
  },
  {
    id: "q_quality",
    text: STRINGS.questionQuality,
    shortLabel: "Qualität der Leistung",
  },
  {
    id: "q_advice",
    text: STRINGS.questionAdvice,
    shortLabel: "Beratung / Betreuung",
  },
  {
    id: "q_again",
    text: STRINGS.questionAgain,
    shortLabel: "Erneute Beauftragung",
  },
];

export const QUESTION_IDS: readonly string[] = QUESTIONS.map((q) => q.id);
